<div class="box">
  <div class="header">
    <div class="title">
      @if (titleIcon) {
        <ppl-icon
          [svgIcon]="titleIcon"
          height="20px"
          width="20px"></ppl-icon>
      }
      {{ title }}
    </div>
    <ng-content select="extra-header-content"></ng-content>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
